<script lang="ts">
    import {getTranslation} from "../../helper/translation";

    export let value = [];
    const i18n = getTranslation();
    let from = Array.isArray(value) && value.length ? value[0] : '';
    let to = Array.isArray(value) && value.length === 2 ? value[1] : '';

    const onChange = () => {
        value = [from, to];
    };
</script>
<div class="acp-cf-value -between -numeric">
	<input type="text" bind:value={from} on:input={onChange}>
	<span>{i18n.between_and}</span>
	<input type="text" bind:value={to} on:input={onChange}>
</div>